import { ARTICLE_NUMBER } from '../constants';

export const articleNumber = (articleNumber, disabled) => ({
    type: ARTICLE_NUMBER,
    payload: { currentArticleNumber: articleNumber, currentSizeDisabled: disabled },
});
